<template>
  <div class="loginbody">
    <el-row style="height: 50px; display: flex; align-items: center;color: white">
      <el-col :span="12">
        <div class="grid-content ep-bg-purple" style="display: flex; align-items: center; height: 100%;">用戶名：{{userInfo.name}}</div>
      </el-col>
      <el-col :span="12">
        <div class="grid-content ep-bg-purple-light" style="display: flex; align-items: center; height: 100%;">賬戶金額：{{userInfo.money}}USD</div>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <h3>选择號碼</h3>
        <div class="number-grid">
          <el-button
              v-for="number in numbers"
              :key="number"
              :type="selectedNumbers.includes(number) ? 'primary' : 'default'"
              @click="toggleNumber(number)"
          >
            {{ number }}
          </el-button>
        </div>

        <el-button type="success" @click="confirmSelection">選好了</el-button>
        <el-button type="danger" @click="clearSelection">全部清空</el-button>

        <h3>已选择的號碼：</h3>
        <el-input
            type="textarea"
            v-model="chosenNumbersDisplay"
            :rows="5"
            readonly
        ></el-input>

        <div style=" display: flex; align-items: center;color: white">
          <p>您选择了 {{ formData.selectedGroups.length }} 注</p>
          <el-input
              v-model="formData.multiple"
              placeholder="输入多少倍"
              type="number"
              :min="1"
              style="margin-left: 10px; width: 30px;height: 25px;"
          ></el-input>倍
          <p style="margin-left: 10px;">金額: {{ totalAmount }}$</p>
        </div>


        <el-button type="primary" @click="purchase" color="red">确认購買</el-button>
      </el-col>
    </el-row>

    <div v-show="thatDayPlaceBet.length>0"
        style="background-color: rgb(204, 204, 204);width: -webkit-fill-available;text-align: left;
        padding: 7px;background-color: #ffc9c9; font-size: 14px;font-weight: bold;margin-top: 10px;">
      近期購買
    </div>

    <div v-for="(item, index) in thatDayPlaceBet" :key="key" class="list_item">
      <div class="list_item_item" style="display: flex">
        <div class="list_item_name">日期</div>
        <span class="list_item_name_value"> {{ item.createTime }}</span>
      </div>
<!--      <div class="list_item_item" style="display: flex">-->
<!--        <div class="list_item_name">几注</div>-->
<!--        <span class="list_item_name_value">{{ item.quantity }}</span>-->
<!--      </div>-->
      <div class="list_item_item" style="display: flex">
        <div class="list_item_name">倍率</div>
        <span class="list_item_name_value">{{ item.multiple }}</span>
      </div>
      <div class="list_item_item" style="display: flex">
        <div class="list_item_name">金額</div>
        <span class="list_item_name_value">{{ item.money }}$</span>
      </div>
      <div class="list_item_item" style="display: flex">
        <div class="list_item_name">號碼</div>
        <div>

          <div class="" style="text-align: left; ">
                <span class="ball "><span
                    :class="['balls-size30', randomColor()]">{{ item.numberOne }}</span></span>
            <span class="ball "><span
                :class="['balls-size30', randomColor()]">{{ item.numberTwo }}</span></span>
            <span class="ball "><span
                :class="['balls-size30', randomColor()]">{{ item.numberThree }}</span></span>
            <span class="ball "><span
                :class="['balls-size30', randomColor()]">{{ item.numberFour }}</span></span>
            <span class="ball "><span
                :class="['balls-size30', randomColor()]">{{ item.numberFive }}</span></span>
            <span class="ball "><span
                :class="['balls-size30', randomColor()]">{{ item.numberSix }}</span></span>
            <span class="ball  font-red" style="font-size: 20px; padding: 0px 0px 0px 5px;">+</span>
            <span class="ball "><span
                :class="['balls-size30', randomColor()]">{{ item.numberSeven }}</span></span>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>


import {thatDayPlaceBet,addPlaceBet,getUserInfo} from "@/js/api/WebIndexApi";

export default {
  name: "WebPlacebet",
  data() {
    return {
      numbers: Array.from({ length: 49 }, (_, i) => (i + 1).toString().padStart(2, '0')),
      selectedNumbers: [],
      userInfo:{
          id: 1,
          account: "johndoe",
          name: "John Doe",
          password: "password123",
          createTime: "2025-07-01 16:02:36",
          money: 100.50
      },
      formData: {
        quantity: 1,
        multiple: 1,
        money: 0.00,
        selectedGroups: [

        ],
      },
      baseMoney: 2000,
      thatDayPlaceBet: [
        {
          id: 1,
          quantity: 1,
          userId: 1,
          multiple: 1,
          money: 100.00,
          numberOne: "11",
          numberTwo: "18",
          numberThree: "22",
          numberFour: "43",
          numberFive: "36",
          numberSix: "28",
          numberSeven: "35",
          createTime: "2025-07-01 16:02:36"
        }
      ]
    };
  },
  mounted() {
    // 页面加载完成后执行的代码
    console.log('页面加载完毕');
    this.getUserInfo();
    this.thatDayPlaceBetS();
  },
  computed: {
    chosenNumbersDisplay() {
      return this.formData.selectedGroups.join('\n');
    },
    totalAmount() {
      this.formData.money=this.formData.selectedGroups.length * this.baseMoney * this.formData.multiple;
      return this.formData.selectedGroups.length * this.baseMoney * this.formData.multiple;
    },
  },
  methods: {
    randomColor() {
      const colors = ["red", "green", "blue"];
      return colors[Math.floor(Math.random() * colors.length)];
    },
    thatDayPlaceBetS() {
      var that = this;
      thatDayPlaceBet({}, function (data) {
        console.log(data)
        that.thatDayPlaceBet = data.result;
      })

    },
    addPlaceBet(){
      var that = this;
      addPlaceBet(that.formData, function (data) {
        console.log(data)
        that.$message.success(data.msg);
        that.selectedNumbers = [];
        that.formData.selectedGroups = [];
        that.formData.multiple=1;
        that.thatDayPlaceBetS();
        that.getUserInfo();
      })
    },
    getUserInfo(){
      var that = this;
      getUserInfo({}, function (data) {
        console.log(data)
        that.userInfo=data.result;

      })
    },


    toggleNumber(number) {
      if (this.selectedNumbers.includes(number)) {
        this.selectedNumbers = this.selectedNumbers.filter(n => n !== number);
      } else {
        if (this.selectedNumbers.length <7) {
          this.selectedNumbers.push(number);
        } else {
            this.$message.warning('最多選擇7個號碼');
        }
      }
    },
    confirmSelection() {
      if (this.selectedNumbers.length ==7 ) {
        if (this.formData.selectedGroups.length < 5) {
          this.formData.selectedGroups.push(this.selectedNumbers.join(', '));
          this.selectedNumbers = [];
        } else {
          this.$message.warning('最多選擇5組號碼');
        }
      } else {
        this.$message.warning('請先選擇號碼');
      }
    },
    clearSelection() {
      this.selectedNumbers = [];
      this.formData.selectedGroups = [];
    },
    purchase() {
      if (this.formData.selectedGroups.length === 0) {
        this.$message.warning('請至少選擇一組號碼進行購買');
      } else {
        this.addPlaceBet();
        // 在这里可以添加购买逻辑，例如调用接口
      }
    },
  },
};
</script>

<style scoped>
.loginbody {
  height: 100%;
  line-height: 100%;
  padding: 10px 10px;
  overflow-y: auto;
  background-color: #1a63b5;
  background-image: url("../assets/loginback.jpg");
  background-size: 100% 100%;
  background-position: center center;
}

 .number-grid {
   display: flex;
   flex-wrap: wrap;
   margin-bottom: 20px;
 }

.number-grid .el-button {
  width: 25px !important;
  height: 25px !important;
  padding:0px !important;
  margin: 5px;
  border-radius: 50%;
}

.list_item {
  background-color: #fff;
  padding: 5px 0px;
  width: 100%;
  border-bottom: 1px solid #cccccc;

}

.list_item_item {
  padding: 5px 10px;
  line-height: 23.5px;
}

.list_item_name {
  width: 35px;
  margin-right: 5px;
  text-align: right;
  font-weight: 700;
  color: #d80011;
}

.list_item_name_value {
  font-size: 14px;
}


.ball {
  display: inline-block;
}


.ball .balls-size30 {
  display: inline-block;
  height: 30px;
  width: 30px;
  text-align: center;
  line-height: 26px;
  background-position: 0px -2px;
  background-size: 30px;
  background-repeat: no-repeat;
  font-size: 12px;
  font-weight: 600;
}
.ball .red {
  background-image: url(data:image/png;base64,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);
  background-position: center; /* 背景图片居中 */
}

.ball .green {
  background-image: url(data:image/png;base64,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);
  background-position: center; /* 背景图片居中 */
}

.ball .blue {
  background-image: url(data:image/png;base64,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);
  background-position: center; /* 背景图片居中 */
}

.el-form-item{
  width: 10% !important;
}

</style>